var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Function to update all caches, from CacheProperties.update, with the new data. */
export function updateCache(storage, data, entries) {
    return __awaiter(this, void 0, void 0, function* () {
        for (const cacheKey in entries) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const value = entries[cacheKey];
            if (value === 'delete') {
                yield storage.remove(cacheKey);
                continue;
            }
            const oldValue = yield storage.get(cacheKey);
            if (oldValue.state === 'loading') {
                throw new Error('cannot update the cache while loading');
            }
            const newValue = value(oldValue, data);
            if (newValue === undefined) {
                yield storage.remove(cacheKey);
                continue;
            }
            yield storage.set(cacheKey, newValue);
        }
    });
}
